module.exports = __webpack_public_path__ + "img/photo-0006.8a490bd3.jpg";